import React from "react";
import { Routes, Route, useParams } from "react-router-dom";

import Guests from "../Guests";
import GuestDetails from "../GuestDetails";
import OnboardGuest from "../OnboardGuest";
import AccessSchedules from "../AccessSchedules";
import SiteEdit from "./SiteEdit";
import AdminSites from "../Admin/AdminSites";
import SiteKeys from "./Keys";
import SiteKeysAudit from "./KeysAudit";

function AccessSchedulesWrapper() {
  const { siteId } = useParams<{ siteId: string }>();
  return <AccessSchedules siteId={siteId!} />;
}

export default function Sites() {
  return (
    <Routes>
      <Route path="/" element={<AdminSites />} />
      <Route path="/:siteId/guests" element={<Guests />} />
      <Route path="/:siteId/guests/:guestId" element={<GuestDetails />} />
      <Route path="/:siteId/onboardguest" element={<OnboardGuest />} />
      <Route path="/:siteId/accessschedules" element={<AccessSchedulesWrapper />} />
      <Route path="/:siteId/edit" element={<SiteEdit />} />
      <Route path="/:siteId/keys-audit" element={<SiteKeysAudit />} />
      <Route path="/:siteId/keys/*" element={<SiteKeys />} />
    </Routes>
  );
}
